import { useCurrentAgreement, useCurrentUser, useHost, useLocalStorage } from '@economic/react-app';

export interface AdminPreferencesData {
    hasAdminCentral: boolean;
    defaultAdminPage: string;
    hasHqAccess: boolean;
    hostFrontendsHQ: string;
    hasKYC: boolean;
    hasOldCompaniesPageAccess: boolean;
}

export default function useAdminPreferences(): AdminPreferencesData {
    const agreement = useCurrentAgreement();
    const user = useCurrentUser();
    const host = useHost();

    const hasHqAccess = agreement.features.hqAccess;
    const hasAdminCentral = agreement.features.adminCentral;
    const hasOldCompaniesPageAccess = agreement.features.oldCompaniesPageAccess;

    const [legacyAdminPageAsDefault] = useLocalStorage<boolean>(`legacyAdminPageAsDefault_${agreement.number}_${user.id}`, false);

    const defaultAdminPage =
        (hasOldCompaniesPageAccess && legacyAdminPageAsDefault) || !hasAdminCentral ? 'companies' : 'central';

    const hasKYC = agreement.features.creditroSetup;

    return {
        hasAdminCentral,
        defaultAdminPage,
        hasHqAccess,
        hostFrontendsHQ: host.frontends.hq,
        hasKYC,
        hasOldCompaniesPageAccess,
    };
}
